<template>
    <div id="upstander_strengths_wrapper" class="min-vh-100">
        <h1 class="explainer1 text-center py-5"><span class="highlight-purple px-2">{{ $t($parent.iKey('personal_strengths_section', 'personal_strengths', 'transition')) }}</span></h1>
        
        <div v-if="profiles" class="ml-lg-5 px-5">
          <div v-for="p in profiles_and_case_studies" :key="p.name"  class="d-inline profile" ref="profile">
            <template v-if="p.meta.type == 'upstander.CaseStudy'" >
              <div class="h2 px-3 d-inline">{{ $t($parent.iKey('related_case_studies', p, 'action')) }}</div>
              <img v-lazy="p.main_image.url_resized_square" class="my-3" :alt="$t($parent.iKey('related_case_studies', p, 'main_image_desc'))">
            </template>
            <template v-else>
              <div class="h2 px-3 d-inline">{{ $t($parent.iKey('related_upstander_profiles', p, 'action')) }}</div>
              <img v-lazy="p.profile_image.url_resized_square" class="my-3" :alt="$t($parent.iKey('related_upstander_profiles', p, 'profile_image_desc'))">
            </template>
          </div>
        </div>

        <div class="explainer1 text-center my-5"><span class="highlight-copper px-2">{{ $t($parent.iKey('personal_strengths_section', 'personal_strengths', 'transition_out')) }}</span></div>
    </div>
</template>

<script>

export default {
  name: 'UpstanderStrengths',
  props: [
    'profiles',
    'case_studies'
  ],
  computed: {
    profiles_and_case_studies: function(){
      return this.profiles.concat(this.case_studies)
    }
  },
  methods: {
    firstName(fullName){
      if(fullName){
        return fullName.split(' ')[0]
      }
      return fullName
    },
    fadeInProfiles(){
        for(let i in this.$refs.profile){
          let obj = this.$refs.profile[i]
          let delay = (Math.random() * (15 - 1) + 1) / 10;
          obj.style.transition = 'all 0.5s ' + delay + 's ease-in-out';
          obj.classList.add('in');
        }
    },
    // fadeOutProfiles(){
    //   for(let i in this.$refs.profile){
    //     let obj = this.$refs.profile[i];
    //     obj.classList.remove('in');  
    //   }
    // }
  },
  mounted(){
    var dur = this.windowHeight
    const scene = this.$scrollmagic.scene({
        triggerElement: '#upstander_strengths_wrapper',
        triggerHook: 0,
        offset: '-150px',
        duration: dur * 1.5
    })
    this.$scrollmagic.addScene(
      scene
          .on('enter', () => {
            this.fadeInProfiles();
          })
          // .on('leave', () => {
          //   this.fadeOutProfiles();
          // })
          //.addIndicators({name: 'Scene 3'})
    )  
  }
}
</script>

<style scoped>

.h2 {
  font-size: 18px;
}
@media (min-width: 576px){
  .h2 {
    font-size: 36px;
  }
}
.highlight-purple {
  background-color: #7575bf;
  color: #fff;
  transform: rotate(3deg);
  display: inline-block;
}
.highlight-copper {
  background-color: #ad841f;
  color: #fff;
  transform: rotate(-2deg);
  display: inline-block;
}
.profiles-wrapper {
  position: relative;
  
  opacity: 0;
  transition: all 1s ease-in-out;
}
.profile {
  opacity: 0;
  top: 10px;
  position: relative;
}

.profile img {
  width: 140px;
  height: 140px;
}

.profile.in {
  opacity: 1.0;
  top: 0px;
}

</style>